var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "id": "modal-search-product",
      "title": "選擇商品"
    },
    on: {
      "show": _vm.handleModelIsOpened
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn() {
        return [_c('div', {
          staticClass: "w-100"
        }, [_c('div', {
          staticClass: "float-right"
        }, [_c('span', {
          staticClass: "mr-2 mdi mdi-chevron-left mdi-36px",
          class: _vm.meta.current_page == 1 ? 'text-muted' : '',
          on: {
            "click": _vm.prevPage
          }
        }), _c('span', {
          staticClass: "mr-5 mdi mdi-chevron-right mdi-36px",
          class: _vm.meta.current_page == _vm.meta.last_page ? 'text-muted' : '',
          on: {
            "click": _vm.nextPage
          }
        }), _c('b-button', {
          staticClass: "mr-2 ml-5",
          attrs: {
            "variant": "danger",
            "size": "sm"
          },
          on: {
            "click": _vm.closeModal
          }
        }, [_vm._v(" 取消 ")]), _c('b-button', {
          attrs: {
            "variant": "primary",
            "size": "sm"
          },
          on: {
            "click": _vm.submitSelectedProducts
          }
        }, [_vm._v(" 確定 ")])], 1)])];
      },
      proxy: true
    }])
  }, [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "placeholder": "請輸入商品名稱"
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetchProducts.apply(null, arguments);
      }
    },
    model: {
      value: _vm.query.keyword,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "keyword", $$v);
      },
      expression: "query.keyword"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    on: {
      "click": _vm.fetchProducts
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])], 1)], 1), _c('div', {
    staticClass: "d-flex align-items-center mt-3"
  }, [_c('span', {
    staticClass: "mr-3",
    staticStyle: {
      "flex": "0 0 auto"
    }
  }, [_vm._v("商品類型：")]), _c('b-form-select', {
    staticClass: "ml-0 ml-xl-2",
    attrs: {
      "options": _vm.productTypeOptions
    },
    on: {
      "change": _vm.fetchProducts
    },
    scopedSlots: _vm._u([{
      key: "first",
      fn: function fn() {
        return [_c('b-form-select-option', {
          attrs: {
            "value": null
          }
        }, [_vm._v("全部類型")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.query.type,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "type", $$v);
      },
      expression: "query.type"
    }
  })], 1), _c('div', {
    staticClass: "d-flex align-items-center mt-3"
  }, [_c('span', {
    staticClass: "mr-3",
    staticStyle: {
      "flex": "0 0 auto"
    }
  }, [_vm._v("商品分類：")]), _c('b-form-select', {
    staticClass: "ml-0 ml-xl-2",
    attrs: {
      "options": _vm.productCategoryOptions
    },
    on: {
      "change": _vm.fetchProducts
    },
    model: {
      value: _vm.query.category,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "category", $$v);
      },
      expression: "query.category"
    }
  })], 1), _vm.isLoading ? _c('div', {
    staticClass: "text-center mt-3 mb-3 loading-spinner"
  }, [_c('b-spinner', {
    attrs: {
      "variant": "secondary",
      "small": ""
    }
  })], 1) : _vm.products.length > 0 ? _c('div', {
    staticClass: "mt-3 mb-3"
  }, _vm._l(_vm.products, function (product) {
    return _c('div', {
      key: product.id,
      staticClass: "d-flex align-items-center py-2 product-item",
      on: {
        "click": function click($event) {
          return _vm.handleSelected(product);
        }
      }
    }, [[_vm.deepGet(product, 'images[0].pic_url') ? _c('b-img-lazy', {
      staticClass: "mx-2 thumb-image flex-shrink-0",
      attrs: {
        "src": _vm.deepGet(product, 'images[0].pic_url'),
        "alt": "商品圖片",
        "width": "50",
        "height": "25"
      }
    }) : _c('div', {
      staticClass: "mx-2 flex-shrink-0",
      style: {
        width: '50px',
        height: '25px'
      }
    })], _c('div', {
      staticClass: "mr-auto text-nowrap text-truncate"
    }, [_c('div', {
      staticClass: "font-weight-bold"
    }, [_vm._v(" " + _vm._s(product.title) + " ")]), _c('small', {
      staticClass: "text-muted"
    }, [_vm._v(" " + _vm._s(_vm.format(new Date(product.available_start_at), 'yyyy-MM-dd HH:mm')) + " ~ " + _vm._s(_vm.format(new Date(product.available_end_at), 'yyyy-MM-dd HH:mm')) + " ")])]), _c('div', {
      staticClass: "mx-2"
    }, [_vm.selectedProductsIdList.includes(product.id) ? _c('span', {
      staticClass: "mdi mdi-check-circle mdi-24px"
    }) : _vm._e()])], 2);
  }), 0) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }